import type { TextI, TickerI } from "tweenly"
import PauseCircleIcon from "@mui/icons-material/PauseCircle"
import PlayCircleIcon from "@mui/icons-material/PlayCircle"
import { Box, Button } from "@mui/material"
import { t } from "i18next"
import { useDispatch } from "react-redux"
import { sumArray } from "../../../../helpers/array.helpers"
import {
    CRAWL_CONTINUES_DURATION,
    CRAWL_STAGGERED_DURATION,
} from "../../../../helpers/crawlTicker.helpers"
import { getElementWidth } from "../../../../helpers/html.helpers"
import { addSubTimelineAnimationAction } from "../../../../store/slices/objects.slice"
import ExpandableSection from "../../../common/ExpandableSection"
import CompactSelect from "../../../common/PropertyTools/CompactSelect"
import PropertyRow from "../../../common/PropertyTools/PropertyRow"
import { TickerInput } from "./TickerInput"
interface Props {
    object: TickerI
    maskObject: TickerI | undefined
    textObjects: TextI[]
    playTimeline: () => void
    pauseTimeline: () => void
}
const CrawlTools = ({ object, maskObject, textObjects, playTimeline, pauseTimeline }: Props) => {
    const dispatch = useDispatch()
    const duration =
        maskObject && maskObject.duration
            ? maskObject.duration
            : maskObject?.tickerType === "crawl-continuous"
            ? CRAWL_CONTINUES_DURATION
            : CRAWL_STAGGERED_DURATION

    const animation = maskObject && Object.values(maskObject?.animations)[0]
    const handleDurationOnChange = (e: any) => {
        const textsWidth = sumArray(textObjects.map((x) => getElementWidth(x?.id)))
        const crawlSpeed = Number(textsWidth) / Number(e.target.value)
        if (animation)
            dispatch(
                addSubTimelineAnimationAction({
                    animations: [
                        {
                            ...animation,
                            duration: crawlSpeed,
                        },
                    ],
                    textAnimations: null,
                    duration: Number(e.target.value),
                    objectId: animation.objectId,
                    updatedAt: Date.now(),
                })
            )
    }
    const handleDirectionOnChange = (e: any) => {
        // to do ... add crawlDirection into maskObject so you can recreate animation by settings and by type of crawl animation(staggered || continuous)
    }
    const crawlDirection = ["right-to-left", "left-to-right"]
    return (
        <ExpandableSection
            expanded={true}
            title={t("editor:tickers.crawlTitle")}
            component={
                <Box display="flex" flexDirection="column" gap={1.5} width="100%" pb={0.5}>
                    <PropertyRow>
                        <Box display="flex" gap={1}>
                            <Box flex={1} minWidth={0}>
                                <TickerInput
                                    inputValue={duration}
                                    handleOnChange={handleDurationOnChange}
                                    name={t("editor:tickers.crawlSpeedName")}
                                    label={t("editor:tickers.crawlSpeed")}
                                    unit={false}
                                />
                            </Box>
                            {/* TO DO - show the direction AFTER implementation CrawlDirection */}
                            <Box flex={1} minWidth={0} visibility="hidden">
                                <CompactSelect
                                    name={t("editor:tickers.crawlDirectionSelectName")}
                                    value={crawlDirection[0]}
                                    options={crawlDirection.map((option) => ({
                                        value: option,
                                        label: option,
                                    }))}
                                    label={t("editor:tickers.crawlDirectionSelect")}
                                    tooltip={t("editor:tickers.crawlDirectionSelect")}
                                    handleOnChange={handleDirectionOnChange}
                                />
                            </Box>
                        </Box>
                    </PropertyRow>
                    <PropertyRow>
                        <Box display="flex" gap={1}>
                            <Button
                                startIcon={<PlayCircleIcon />}
                                color="success"
                                variant="text"
                                onClick={() => playTimeline()}
                            >
                                {t("play")}
                            </Button>
                            <Button
                                startIcon={<PauseCircleIcon />}
                                color="error"
                                variant="text"
                                onClick={() => pauseTimeline()}
                            >
                                {t("stop")}
                            </Button>
                        </Box>
                    </PropertyRow>
                </Box>
            }
        />
    )
}

export default CrawlTools
